<script>
export default {
  props: {
    chat: {
      type: Object,
      required: true,
    },
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    mentions(str) {
      return str
        .replace(
          /"(\w+)">(@[\w\s\-'áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]*)</g,
          '"$1"><a href="/user/$1/profile">$2</a><',
        )
        .replace(
          /(@[\w\s\-'áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]*)#(\w+)/g,
          '<a href="/user/$2/profile" class="mention">$1</a>',
        );
    },

    format(str) {
      return this.mentions(str.replace(/<p><\/p>/g, '<p><br></p>'));
    }
  }
};
</script>

<template>
  <section
    class="attendence"
  >
    <header
      class="attendence-header"
    >
      <div class="attendant">
        <Avatar
          :name="chat.attendence.attendant"
          width="32"
          class="rounded-circle"
        />
        <span
          class="attendant-name"
        >
          {{ chat.attendence.attendant }}
        </span>
        <div class="attendance-brand">
          <img src="/build/icons/whatsapp-forwhats.svg"/>
          <span>Forwhats</span>
        </div>
      </div>
      <div v-if="chat.content" class="attendance-note" v-html="format(chat.content)"></div>
    </header>
    <div class="attendence-messages pt-1">
      <LeadAttendenceMessage 
        v-for="message in chat.attendence.messages"
        :message="message"
        :attendant="chat.attendence.attendant"
        :lead="lead"
      />
    </div>
    <footer class="attendence-footer">
      <span>
        {{ __('Via integração Forwhats') }}
      </span>
    </footer>
  </section>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.attendence {
  display: flex;
  flex-direction: column;
}

.attendence-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 7px;
  border-bottom: 1px solid $salesflow-outline-gray-medium;
}    

.attendant {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 48px;
}

.attendant-name {
  @include salesflow-text($font-weight: 600);
  font-family: 'Inter';
  font-size: 14px;
}

.attendance-brand {
  display: flex;
  align-items: center;
  gap: 4px;
  
  span {
    color: $salesflow-font-gray;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.attendance-note {
  padding: 8px 0;
}

::v-deep .attendance-note p {
  color: $salesflow-font-dark;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0 !important;
}

.separator {
  width: 1px;
  height: 1rem;
  background-color: $salesflow-outline-gray-medium;
}

.attendence-messages {
  max-height: 34rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.attendence-footer {
  border-top: 1px solid $salesflow-outline-gray-medium;
  display: flex;
  justify-content: end;
  padding: 8px;
  color: $salesflow-font-gray;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>